import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [recordarme, setRecordarme] = useState(false);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      const result = await login({ email, password }, recordarme);
      
      if (result.success) {
        navigate('/');
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError('Error al iniciar sesión');
      console.error('Error de login:', error);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo-rv-azul.png" alt="RV Logo" />
        </div>
        <h1 className="auth-title">Iniciar sesión</h1>
        
        <p className="auth-subtitle">
          ¿No tienes una cuenta?{' '}
          <Link to="/register" className="auth-link">Regístrate aquí</Link>
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            placeholder="Email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />

          <div className="auth-input-wrapper">
            <input
              type={mostrarPassword ? "text" : "password"}
              placeholder="Contraseña*"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="auth-input"
            />
            <button
              type="button"
              className="auth-password-toggle"
              onClick={() => setMostrarPassword(!mostrarPassword)}
              tabIndex="-1"
            >
              {mostrarPassword ? (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>

          <div className="auth-options">
            <label className="auth-checkbox">
              <input
                type="checkbox"
                checked={recordarme}
                onChange={(e) => setRecordarme(e.target.checked)}
              />
              <span>Recordarme</span>
            </label>
            <Link to="/forgot-password" className="auth-link-small">
              ¿Olvidaste la contraseña?
            </Link>
          </div>

          <label className="auth-checkbox auth-policy">
            <input type="checkbox" required />
            <span>
              Acepto la <Link to="/en-construccion" className="auth-link-underline">Política de uso de datos personales</Link>
            </span>
          </label>

          <button type="submit" className="auth-button" disabled={cargando}>
            {cargando ? 'Iniciando...' : 'Iniciar sesión'}
          </button>
        </form>

      </div>

      <button className="auth-book-btn" onClick={() => { window.location.href = 'https://rodrigovillanuevallanos.com/libro'; }}>
        Más del libro aquí
      </button>

    </div>
  );
};

export default Login;

